import 'src/shared.css.ts.vanilla.css?source=';
export var hasChevron = 'tabula_ui_multi_selector__1svmv054';
export var sizes = {small:'tabula_ui_multi_selector__1svmv052',medium:'tabula_ui_multi_selector__1svmv053'};
export var variants = {accent:'tabula_ui_multi_selector__1svmv050',contrast:'tabula_ui_multi_selector__1svmv051'};